export default "/assets/webpack-assets/GT-Walsheim-Pro-Light-Oblique.9869d306e394214a2a8edb323801e768.ttf";